import { render, staticRenderFns } from "./ConcantUs.vue?vue&type=template&id=67549eb1&scoped=true&"
import script from "./ConcantUs.vue?vue&type=script&lang=js&"
export * from "./ConcantUs.vue?vue&type=script&lang=js&"
import style0 from "./ConcantUs.vue?vue&type=style&index=0&id=67549eb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67549eb1",
  null
  
)

component.options.__file = "ConcantUs.vue"
export default component.exports